import PlanningExportLevelsEnum from '../Enums/PlanningExportLevelsEnum';

export default class PlanningExportItem {
  constructor(init) {
    const data = init || {};
    this.Level = data.Level || PlanningExportLevelsEnum.Detail;
    this.SelectedIds = data.SelectedIds || [];
    // Default granularity = the level itself (e.g. service grid defaults to service summary)
    this.Granularity = data.Granularity || this.Level;
  }
}
